import script from "./SalesOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./SalesOverview.vue?vue&type=script&setup=true&lang=js"

import "./SalesOverview.vue?vue&type=style&index=0&id=6540fa7f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6540fa7f"]])

export default __exports__